import Controller, { inject as controller } from '@ember/controller';
import { action } from '@ember/object';
import LoginController from 'cio/pods/login/controller';
import { removeTwoFactorAuthLinkCookie } from 'cio/utils/auth-cookies';
import { task } from 'ember-concurrency';

export default class TwoFactorAuthEmailLinkController extends Controller {
  queryParams = ['token'];

  @controller('login') loginController!: LoginController;

  validateTwoFactorAuthLinkToken = task(async (token: string) => {
    this.loginController.set('twoFactorAuthLinkToken', token);
    await this.loginController.loginTaskTwoFactorAuthLink.perform();
  });

  @action
  useDifferentEmail() {
    removeTwoFactorAuthLinkCookie();
    return this.loginController.useDifferentEmail();
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'login/2fa_email_link': TwoFactorAuthEmailLinkController;
  }
}
